// AUD/year valuation model — exact base numbers per brief, plus data-broker resale multipliers.

export const PLATFORMS = {
  facebook_instagram: 85,
  google: 70,
  youtube: 45,
  tiktok: 25,
  linkedin: 20,
  snapchat: 15,
  x_twitter: 10,
};

export const SHOPPING = { rarely: 10, monthly: 35, weekly: 65, several_weekly: 95 };
export const SHOP_SCALE = { rarely: 0.6, monthly: 0.8, weekly: 1.0, several_weekly: 1.2 };

export const LOYALTY = { none: 0, "1-2": 55, "3-5": 120, "6+": 190 };
export const STREAMING = { none: 0, "1-2": 15, "3+": 30 };

export const FOOTPRINT = {
  under_20: { value: 15, mult: 1.5 },
  "20-50": { value: 35, mult: 2.0 },
  "50-100": { value: 60, mult: 2.5 },
  "100+": { value: 90, mult: 3.0 },
};

export const AGE = { "18-24": 1.0, "25-34": 1.15, "35-44": 1.15, "45-54": 1.0, "55+": 0.85 };

// Each platform resells your data across its own ad + partner network.
export const PLATFORM_NETWORK_PER_APP = 0.09;

// Your info is packaged and re-sold by data brokers — often many times over.
export const BROKER_RESALE = { under_20: 1.25, "20-50": 1.5, "50-100": 1.75, "100+": 2.1 };

// Rough count of companies/partners that end up touching your data.
export const BROKER_COMPANIES = { under_20: 45, "20-50": 95, "50-100": 170, "100+": 260 };
export const PARTNERS_PER_PLATFORM = 14;

export function calculate(state) {
  const apps = state.apps || [];
  const platforms = apps.reduce((s, id) => s + (PLATFORMS[id] || 0), 0);
  const shopping = SHOPPING[state.shopping] || 0;
  const scaledLoyalty = (LOYALTY[state.loyalty] || 0) * (SHOP_SCALE[state.shopping] ?? 1);
  const streaming = STREAMING[state.streaming] || 0;
  const fp = FOOTPRINT[state.footprint] || { value: 0, mult: 1 };
  const ageMult = AGE[state.age] ?? 1;

  const footprintValue = fp.value;
  const footprintMult = fp.mult;

  // extra reality multipliers
  const platformNetworkMult = 1 + PLATFORM_NETWORK_PER_APP * apps.length;
  const brokerMult = BROKER_RESALE[state.footprint] ?? 1;

  const subtotal = platforms + shopping + scaledLoyalty + streaming + footprintValue;
  const total = subtotal * footprintMult * ageMult * platformNetworkMult * brokerMult;

  const companies = Math.round(
    apps.length * PARTNERS_PER_PLATFORM + (BROKER_COMPANIES[state.footprint] ?? 0)
  );

  return {
    total: Math.round(total),
    subtotal: Math.round(subtotal),
    companies,
    multipliers: [
      { key: "footprint", label: "Account footprint", value: footprintMult },
      { key: "age", label: "Age bracket", value: ageMult },
      { key: "network", label: `Platform networks (${apps.length} app${apps.length === 1 ? "" : "s"})`, value: platformNetworkMult },
      { key: "broker", label: "Data-broker resale chain", value: brokerMult },
    ],
    breakdown: [
      { key: "platforms", label: "Apps & platforms", value: Math.round(platforms) },
      { key: "shopping", label: "Online shopping", value: Math.round(shopping) },
      { key: "loyalty", label: "Loyalty programs", value: Math.round(scaledLoyalty) },
      { key: "streaming", label: "Streaming services", value: Math.round(streaming) },
      { key: "footprint", label: "Account footprint", value: Math.round(footprintValue) },
    ],
  };
}
